const transatelMobileProduct = {
  index: {
  },
  tab: {
    main: "Référence Transatel",
  },
  new: {
    title: "Nouveau produit mobile transatel"
  },
  search: {
    number: "Nom",
  }
};

export default transatelMobileProduct;
